import { DOCUMENT } from '@angular/common'
import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'

import { UI_SKIN_BODY_CLASS_BY_KEY, UI_SKIN_BODY_CLASSES } from '../../skins/skin-registry'
import { DomainService } from './domain.service'
import { WhiteLabelService } from './white-label.service'

@Injectable({
	providedIn: 'root',
})
export class ThemeService {
	constructor(
		@Inject(DOCUMENT) private readonly document: Document,
		readonly domainService: DomainService,
		readonly http: HttpClient,
		private readonly whiteLabelService: WhiteLabelService,
	) {}

	initTheme() {
		this.loadTheme()
		this.updateFavicon(`${this.domainService.wlAssetURL}/favicon.png`)
		this.updateTitle(this.domainService.title)
	}

	loadTheme(): void {
		const domain = this.domainService.domain
		const themeClass = domain.replace('.', '_')
		document.body.classList.forEach((cls) => {
			if (cls.endsWith('_com') || cls.endsWith('_net')) {
				document.body.classList.remove(cls)
			}
		})
		document.body.classList.add(themeClass)
		UI_SKIN_BODY_CLASSES.forEach((skinClass) => document.body.classList.remove(skinClass))
		document.body.classList.add(UI_SKIN_BODY_CLASS_BY_KEY[this.whiteLabelService.activeSkin()])
		document.body.classList.toggle('ui-exchange-compact', this.whiteLabelService.isV2Skin())
	}

	updateFavicon(faviconPath: string): void {
		const link: HTMLLinkElement = this.document.querySelector("link[rel*='icon']") || this.document.createElement('link')
		link.type = 'image/x-icon'
		link.rel = 'shortcut icon'
		link.href = faviconPath
		this.document.getElementsByTagName('head')[0].appendChild(link)
	}

	updateTitle(title: string): void {
		this.document.title = title
	}
}
